import { ICountry } from "../../models/ICountry";

export class CountryState {
  country: ICountry[] = [];
}
